import { FC } from 'react'
import Link from 'next/link'
import { Row, Col, Text, Breadcrumb, List, ListItem, Button, Image } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({
  breadcrumb,
  name,
  description,
  benefits,
  cta,
  currency,
  minimum_price,
  image_type,
  product_image,
  featured_styles,
  inverse_color
}) => (
  <S.Featured $imageUrl={featured_styles?.background_image.url} $background_color={featured_styles?.background_color}>
    <Row>
      <Col>{breadcrumb && <Breadcrumb pages={breadcrumb} inverse={inverse_color} />}</Col>
    </Row>
    <Row>
      <Col>
        <S.MainFeatured>
          <S.LeftFeatured
            $button_color={featured_styles?.button_color}
            $button_text_color={featured_styles?.button_text_color}
            $text_color={featured_styles?.text_color}
          >
            {name && (
              <Text as='h1' size='h3' family='heading' weight='bold' itemProp='name' className='header_text'>
                <span dangerouslySetInnerHTML={{ __html: name }} />
              </Text>
            )}

            {description && (
              <Text
                as='h4'
                color='weak'
                size='xlg'
                family='heading'
                weight='medium'
                margin='0 0 2rem'
                itemProp='description'
                className='header_description'
              >
                <span dangerouslySetInnerHTML={{ __html: description }} />
              </Text>
            )}

            {benefits && benefits?.length > 0 && (
              <List kind='gold'>
                {benefits.map(({ benefit_item }) => (
                  <ListItem key={benefit_item} className='benefits_list'>
                    <span dangerouslySetInnerHTML={{ __html: benefit_item }} className='list_text' />
                  </ListItem>
                ))}
              </List>
            )}

            {cta && cta.link && cta.label && (
              <Link href={cta.link}>
                <Button className='calc_button'>
                  <span className='button_text'>{cta.label}</span>
                </Button>
              </Link>
            )}

            {currency && currency && (
              <div itemProp='offers' itemScope itemType='http://schema.org/Offer'>
                <link itemProp='availability' href='http://schema.org/InStock' />
                <S.SchemaSpan itemProp='priceCurrency' content={currency} />
                <S.SchemaSpan itemProp='price' content={minimum_price.toString()} />
              </div>
            )}
          </S.LeftFeatured>

          <>
            {!featured_styles?.background_image.id && (
              <S.Product>
                <S.ProductImg>
                  <S.FilledSquare />
                  <S.OutlinedSquare />
                  {product_image && (
                    <>
                      <Image
                        alt={product_image.alt || name}
                        src={product_image.url || '/img/404.png'}
                        width={product_image.width}
                        height={product_image.height}
                        priority
                      />
                      <link itemProp='image' href={product_image.url} />
                    </>
                  )}

                  {image_type && (
                    <S.ProductType>
                      <Image
                        alt={image_type.alt || name}
                        src={image_type.url || '/img/404.png'}
                        width={image_type.width}
                        height={image_type.height}
                        priority
                      />
                    </S.ProductType>
                  )}
                </S.ProductImg>
              </S.Product>
            )}
          </>
        </S.MainFeatured>
      </Col>
    </Row>
  </S.Featured>
)
